import React from "react";
import MinimalPublicPage from "./MinimalPublicPage";

export default function SupportPage() {
  return (
    <MinimalPublicPage
      eyebrow="Support"
      title="Need help? Start here."
      description="Get account help, report a match issue, or ask for support from the Ouro team."
      points={[
        {
          title: "Submit a ticket",
          body: "Use your account support area for the fastest help with account-specific issues.",
        },
        {
          title: "Match issues",
          body: "Include match details and context so reports can be reviewed properly.",
        },
        {
          title: "Privacy requests",
          body: "For data requests, email support@ouro.is.",
        },
      ]}
      secondaryLabel="FAQ"
      secondaryTo="/faq"
    />
  );
}
